module.exports = __webpack_public_path__ + "img/logo-albarran-black.3ed005b6.png";